import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addTribute, getTributes } from "../redux/actions/profile";
import TributeModal from "./TributeModal";
import { toast } from "react-toastify";

const TributeSection = ({ medallionId }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [tributes, setTributes] = useState([]);
  const [showTributeModal, setShowTributeModal] = useState(false);

  useEffect(() => {
    if (medallionId) {
      fetchTributes();
    }
  }, [medallionId]);

  const fetchTributes = async () => {
    try {
      const response = await dispatch(getTributes(medallionId)).unwrap();
      setTributes(response.data || []);
    } catch (error) {
      console.error("Error fetching tributes:", error);
    }
  };

  const handleTributeSubmit = async (values) => {
    try {
      const payload = {
        name: values.author,
        message: values.message,
        medallion_id: medallionId,
      };

      await dispatch(addTribute(payload)).unwrap();
      await fetchTributes();
      setShowTributeModal(false);
      toast.success("Tribute submitted successfully!");
    } catch (error) {
      console.error("Error submitting tribute:", error);
      toast.error("Failed to submit tribute");
    }
  };

  const handlePurchaseGift = () => {
    navigate(`/ar/${medallionId}`);
  };

  return (
    <>
      <div className="tribute-data">
        <div className="d-flex justify-content-start gap-3">
          <button onClick={() => setShowTributeModal(true)}>
            Submit a Tribute
          </button>
          <button
            onClick={handlePurchaseGift}
            style={{ display: "flex", alignItems: "center", gap: "8px" }}
          >
            <img
              src={require("../assets/images/gift-align-frame.png")}
              alt="Gift"
              style={{ width: "20px", height: "20px" }}
            />
            Send Gifts
          </button>
        </div>
        <div className="tribute-cards">
          {tributes.map((tribute, index) => (
            <div
              className={`tribute-items`}
              key={index}
              style={{ position: "relative" }}
            >
              {tribute.gift_id && (
                <img
                  src={require("../assets/images/gift-frame.png")}
                  alt="Gift"
                  style={{
                    position: "absolute",
                    top: "-15px",
                    left: "-14px",
                    width: "30px",
                    height: "30px",
                    zIndex: 1,
                  }}
                />
              )}
              <div className={tribute.gift_id ? "gift-tribute" : ""}>
                <h5>{tribute.name || tribute?.user_id?.name || "Guest"}</h5>
                <p>
                  {new Date(tribute.createdAt)
                    .toLocaleDateString("en-GB", {
                      day: "numeric",
                      month: "long",
                      year: "numeric",
                    })
                    .replace(/^(\d+)/, (match) => {
                      const day = parseInt(match);
                      const suffix =
                        day % 10 === 1 && day !== 11
                          ? "st"
                          : day % 10 === 2 && day !== 12
                          ? "nd"
                          : day % 10 === 3 && day !== 13
                          ? "rd"
                          : "th";
                      return day + suffix;
                    })}
                </p>
              </div>
              <div className="">
                <p className={`${tribute.gift_id ? "bold-class" : ""}`}>
                  {tribute.gift_id
                    ? `Gifted ${tribute.gift_id.name}`
                    : tribute.message}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <TributeModal
        show={showTributeModal}
        onHide={() => setShowTributeModal(false)}
        onSubmit={handleTributeSubmit}
      />
    </>
  );
};

export default TributeSection;
